import { useState } from "react";

// زر طبقة التقرير مع تأثير ضغط فوري (inline styles لا تدعم :active، فنُحاكيه بحالة React).
// يعمل باللمس (pointer/touch) داخل WebView للتطبيق وعلى الويب.
const RAISED = "0 6px 0 rgba(0,0,0,.3), 0 12px 22px rgba(0,0,0,.28),"
  + " inset 0 2px 0 rgba(255,255,255,.55), inset 0 -4px 10px rgba(0,0,0,.22)";
const PRESSED = "0 1px 0 rgba(0,0,0,.3), inset 0 2px 0 rgba(255,255,255,.3),"
  + " inset 0 -2px 6px rgba(0,0,0,.25)";

export const OverlayButton = ({ testid, background, onClick, children }) => {
  const [down, setDown] = useState(false);
  const press = () => setDown(true);
  const release = () => setDown(false);
  return (
    <button
      type="button"
      data-testid={testid}
      onPointerDown={press}
      onPointerUp={release}
      onPointerLeave={release}
      onPointerCancel={release}
      onTouchStart={press}
      onTouchEnd={release}
      onClick={onClick}
      style={{
        flex: "1 1 44%", display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
        border: 0, borderRadius: 12, padding: "11px 6px", color: "#fff", fontWeight: 900,
        fontSize: 15, cursor: "pointer", minWidth: 0, whiteSpace: "nowrap",
        touchAction: "manipulation", WebkitTapHighlightColor: "transparent", userSelect: "none",
        background, textShadow: "0 2px 3px rgba(0,0,0,.4)",
        transition: "transform .09s ease, box-shadow .09s ease",
        transform: down ? "translateY(4px)" : "translateY(0)",
        boxShadow: down ? PRESSED : RAISED,
      }}
    >
      {children}
    </button>
  );
};
